/* eslint-disable no-useless-escape */
const is = {
  details: (route) => {
    return /^\/scholarships\/((?:[^\/]+?))\/((?:\d+))(?:\/(?=$))?$/i.test(route.path) && route.params.tabName !== 'submitted'
  },
  editor: (route) => {
    return /^\/scholarships\/((?:[^\/]+?))\/((?:\d+))\/((?:\d+))(?:\/(?=$))?$/i.test(route.path)
  }
}

const moduleName = 'engagementModalBehavior'

export default ({ app, store }) => {
  app.router.beforeEach(async(to, from, next) => {
    if (is.details(to)) {
      await store.dispatch(`${moduleName}/visit`, { scholarshipId: to.params.cardId })

      if (is.editor(from)) {
        store.commit(`${moduleName}/setState`, { stateName: 'isEngaged', data: true })
      }
    }

    if (is.details(from)) {
      if (is.editor(to)) {
        store.commit(`${moduleName}/setState`, { stateName: 'isEngaged', data: true })
      }

      await store.dispatch(`${moduleName}/leave`, { scholarshipId: from.params.cardId })
    }

    next()
  })
}
